import React from 'react';
import { CareMapprTextarea } from '../../../../../components/Inputs/textarea';
import { LetterType } from '../PharmacistDoctorLetterSection';
import { useLettersForm } from '../provider/LettersFormContext';
import CareMapprButton from '../../../../../components/Button/CareMapprButton';
import { useMedicationProfileDirty } from '../../../context/MedicationProfileDirtyProvider';

interface MedicationChangesProps {
  type: LetterType;
}

const MedicationChanges = ({ type }: MedicationChangesProps) => {
  const {
    pharmacistLetterForm,
    doctorLetterForm,
    onGenerateMedicationChanges,
  } = useLettersForm();
  const { setIsDirty } = useMedicationProfileDirty();
  const medicationChanges =
    type === LetterType.PHARMACIST
      ? pharmacistLetterForm.getValues().medicationChanges || ''
      : doctorLetterForm.getValues().medicationChanges || '';
  return (
    <div className="letters-form-add-item">
      <div className="d-flex flex-column gap-2">
        <label>Medication changes this admission</label>
        <div className="d-flex flex-column gap-2">
          <CareMapprTextarea
            autoResize
            placeholder="Start typing..."
            controlId={`medication-change`}
            value={medicationChanges}
            onChange={(e) => {
              setIsDirty(true);
              if (type === LetterType.PHARMACIST) {
                pharmacistLetterForm.setValue(
                  `medicationChanges`,
                  e.target.value,
                  { shouldDirty: true },
                );
              } else {
                doctorLetterForm.setValue(`medicationChanges`, e.target.value, {
                  shouldDirty: true,
                });
              }
            }}
          />
          <CareMapprButton
            extraClassNames="ms-auto my-0 width-120"
            variant="secondary"
            label="Generate"
            type="button"
            onClick={() => {
              onGenerateMedicationChanges(type);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default MedicationChanges;
